/* RESPONSIBLE TEAM: team-frontend-tech */
import TagPredicateManager from 'embercom/lib/common/predicates/tag-predicate-manager';

export default TagPredicateManager.extend({
  defaultComparison: 'eq',
  goalComparison: 'eq',
});
